import { useNavigate } from "react-router-dom";
import { CustomDataTable, filterData } from "../utilities/Actions/Hooks"
import { ReportsToolbar, UsersToolbar } from "../utilities/Reusable/ReportToolbar"
import { useContext, useEffect, useMemo, useState } from "react";
import axios from "axios";
import { UsersColumn } from "../utilities/ArrayHelper/ReportColumn";
import { ModalForm } from "./Modal";
import { UserContext } from "./UserContext";
import { DashboardContext } from "../dashboard/DashboardContext";
import { BaseUrlContext } from "../context/BaseUrlContext";
import { toast } from "react-toastify";

export const Users = () => {
  const navigate = useNavigate();
    const { users, setUsers, handleLogout, handleOpenCreateModal, handleCloseCreateModal, handleOpenEditModal, handleCloseEditModal,
       handleChange, handleSubmit, handleUpdate, handleDelete,error,setError,fetchUserData}=useContext(UserContext);
    const {allReports,setAllReports,userData,setUserData,handleLogin,handleLoginUserReports,tokenKey,setTokenKey}=useContext(DashboardContext);
     const { BaseUrl } = useContext(BaseUrlContext);
     useEffect(() =>{
        if(!BaseUrl) return;  
        if(!tokenKey){
          navigate("/");
          return;
        }
          axios.get(`${BaseUrl}user/getAll`,{
            headers: { Authorization: `Bearer ${tokenKey}` }
          })
          .then((res) => {
            setUsers(res.data);
          })
        }
      , [BaseUrl]);
    // console.log(userData, "dfsdda");
        const [searchTerm, setSearchTerm] = useState('');
        const filteredData = useMemo(
            () => filterData(users, searchTerm, ["userName", "userType", "userAdmin", "userPassword"]),
            [users, searchTerm]
        );
    return (
        <>
            <div className="container-fluid" style={{background: 'linear-gradient(to bottom left, #c7efffff, #f9f9f9)'}}>
              <div className=" d-flex justify-content-between align-items-center p-3">
                <div className="d-flex align-items-center gap-2">
                    {/* <button type="button" className="btn arrow-btn" > */}
                      <i onClick={() => navigate(-1)} style={{background: 'none',borderColor: 'none',color: '#00ABEF',fontSize: '26px'}} className="arrow-btn bi bi-arrow-left"></i>
                    {/* </button> */}
                      <h5 className="userName">{userData?.userName}</h5>
                </div>
                  <button className="logout btn" style={{background: '#00ABEF',borderColor: '#00ABEF',color: 'white'}} onClick={handleLogout}>Logout</button>
              </div>
            </div>
        
            <div className="container-fluid mt-3 ">
              <div className="container-fluid content">
              <UsersToolbar
              onAdd={handleOpenCreateModal}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}

              />
              
              <CustomDataTable
                columns={UsersColumn(handleOpenEditModal, handleDelete)}
                data={filteredData || []}                        
                paginationPerPage={10}
                paginationRowsPerPageOptions={[5, 10, 15]}
                select={false}
              />
              <ModalForm mode="create" />
              <ModalForm mode="edit" />
              </div>
            </div>
            
            </>
    )
}